import { createAction, props } from '@ngrx/store';
import { UserProfile } from 'src/app/models/user-profile.model';
export const loadUserProfile = createAction(
  '[User Profile] Load User Profile',
  props<{ phoneNumber: string }>()
);

export const loadUserProfileSuccess = createAction(
  '[User Profile] Load User Profile Success',
  props<{ userProfile: UserProfile }>()
);

export const loadUserProfileFailure = createAction(
  '[User Profile] Load User Profile Failure',
  props<{ error: string }>()
);

export const updateUserProfile = createAction(
  '[User Profile] Update User Profile',
  props<{ updates: Partial<UserProfile> }>()
);

export const updateUserProfileSuccess = createAction(
  '[User Profile] Update User Profile Success',
  props<{ userProfile: UserProfile }>()
);

export const updateUserProfileFailure = createAction(
  '[User Profile] Update User Profile Failure',
  props<{ error: string }>()
);